<template>
  <div>
    <section-title has-line title="Evaluación de Rúbrica" />

    <validation-observer ref="evaluationForm">
      <div class="row">
        <div class="col-12">
          <validation-provider v-slot="{ errors, validate }" rules="required">
            <custom-radio
              :key="radioKey"
              v-model="isSpecialEvaluatorRequiredOpt"
              class="custom-radio"
              custom-error-msg="El campo es requerido."
              :disabled="isReadOnly"
              is-inline
              :label="'¿Esta Rúbrica va a requerir evaluador Especializado?'"
              name="isSpecialEvaluatorRequired"
              :options="options"
              @input="
                (val) => {
                  validate(val);
                  resetModelSections(val);
                }
              "
            />
            <error v-if="errors[0]" :message="errors[0]" variant="no-border" />
          </validation-provider>
        </div>
        <div
          v-if="isSpecialEvaluatorRequiredOpt?.value === true"
          class="col-12 mt-3"
        >
          <special-evaluator-sections
            ref="sections"
            v-model="model.specialEvaluatorSections"
            :read-only="isReadOnly"
            :sections="sanitizedSections"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomRadio from 'custom-radio';
import Error from 'custom-error';
import SpecialEvaluatorSections from './SpecialEvaluatorSections.vue';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'Evaluation',
  components: { SectionTitle, CustomRadio, Error, SpecialEvaluatorSections },
  mixins: [alertMixin],
  props: {
    sections: { type: Array, default: () => [] },
    value: { type: Object, default: () => ({}) },
    isReadOnly: { type: Boolean, default: false },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    sanitizedSections() {
      return (this.sections || []).map((section) => ({
        ...section,
        name: section.name?.replace(/:\s*$/, ''),
      }));
    },
    radioKey() {
      const v = this.model?.isSpecialEvaluatorRequired;
      return v === true ? 'yes' : v === false ? 'no' : 'none';
    },
    isSpecialEvaluatorRequiredOpt: {
      get() {
        const v = this.model?.isSpecialEvaluatorRequired;
        return this.options.find((o) => o.value === v) || null;
      },
      set(option) {
        const val = typeof option?.value === 'boolean' ? option.value : null;

        this.$emit('input', {
          ...this.model,
          isSpecialEvaluatorRequired: val,
          specialEvaluatorSections:
            val === false ? [] : this.model?.specialEvaluatorSections || [],
        });
      },
    },
    options() {
      return [
        { id: 1, name: 'yes', label: 'Si', value: true },
        { id: 2, name: 'no', label: 'No', value: false },
      ];
    },
  },
  methods: {
    resetModelSections(opt) {
      const v = typeof opt?.value === 'boolean' ? opt.value : null;
      if (v === false) this.model.specialEvaluatorSections = [];
    },
    async validate() {
      const okRadio = await this.$refs.evaluationForm.validate();

      if (
        this.model.isSpecialEvaluatorRequired === true &&
        this.$refs.sections
      ) {
        const okSections = await this.$refs.sections.validate();
        return okRadio && okSections;
      }
      return okRadio;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep label:not(.custom-control-label) {
  color: #6c757d !important;
  font-size: 14px;
}
</style>
